import axios from 'axios';
import { environment, url } from 'src/environments';

//ONBOARDING APPLICANT RISKS
export const evidenceRisksAPI = async (input) => {
  try {
    const riskRequest = await axios.post(
      `${url}/${environment}/admin/documents/investor/evidence-of-risks`,
      input
    );
    return riskRequest;
  } catch (error) {
    console.error(error);
  }
};

export const miFielDocumentAPI = async (file) => {
  try {
    const miFielRequest = await axios.post(
      `${url}/${environment}/mifiel/documents/create-document`,
      file
    );
    return miFielRequest;
  } catch (error) {
    console.error(error);
  }
};

export const literaxRisksAPI = async (body) => {
  try {
    const literaxRequest = await axios.post(
      `${url}/${environment}/admin/literax/emision/pdf`,
      body
    );
    return literaxRequest;
  } catch (error) {
    console.error(error);
  }
};

export const literaxSatwsAPI = async (body) => {
  try {
    const [sendFiles] = await Promise.all([
      axios.post(`${url}/${environment}/admin/satws/send-files-to-aws`, body)
    ]);
    return { sendFiles };
  } catch (error) {
    console.error(error);
  }
};

export const literaxCreditCircleAPI = async (body) => {
  try {
    const [creditAnalysis, creditCircle, satwsFiles, matiFiles] = await Promise.all([
      axios.post(`${url}/${environment}/admin/literax/all-info-credit-analysis`, body),
      axios.post(`${url}/${environment}/admin/literax/all-info-circulo-de-credito`, body),
      axios.post(`${url}/${environment}/admin/literax/emision/satws-files`, body),
      axios.post(`${url}/${environment}/admin/mati/send-files-to-aws`, body)
    ]);
    return { creditAnalysis, creditCircle, satwsFiles, matiFiles };
  } catch (error) {
    console.error(error);
  }
};

export const literaxCreditAnalysisAPI = async (body) => {
  try {
    const literaxRequest = await axios.post(
      `${url}/${environment}/admin/literax/all-info-credit-analysis`,
      body
    );
    return literaxRequest;
  } catch (error) {
    console.error(error);
  }
};
//////

export const simafReqAPI = async (input) => {
  try {
    const response = await axios.get(`${url}/${environment}/admin/simaf-ids?id=${input}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const pdfInvestorGeneralContractAPI = async (input) => {
  try {
    const generalContract = await axios.post(
      `${url}/${environment}/admin/documents/investor/contract-commission`,
      input
    );
    return generalContract;
  } catch (error) {
    console.error(error);
  }
};

export const circleCreditAPI = async (input) => {
  try {
    const maximumPayment = input
      ? await axios.post(
          `${url}/${environment}/circulo-de-credito/credit-analysis/maximum-payment-term`,
          input
        )
      : null;
    const creditAutofill = input
      ? await axios.post(`${url}/${environment}/circulo-de-credito/credit-analysis/autofill`, input)
      : null;
    const borrowingCapacity = input
      ? await axios.post(
          `${url}/${environment}/circulo-de-credito/credit-analysis/borrowing-capacity`,
          input
        )
      : null;
    const commonInput = input;
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const endpoints = [
      `${url}/${environment}/circulo-de-credito/credit-analysis/entity-grants-credit`,
      `${url}/${environment}/circulo-de-credito/credit-analysis/historic-queries`,
      `${url}/${environment}/circulo-de-credito/credit-analysis/number-credit-grantors`,
      `${url}/${environment}/circulo-de-credito/credit-analysis/rating`
    ];

    const makeRequestsWithDelay = async (input, delayMs) => {
      const results = [];
      for (const endpoint of endpoints) {
        const response = await axios.post(endpoint, input);
        results.push(response);
        await delay(delayMs);
      }
      return results;
    };
    let entityCredit, historicQueries, creditGrantors, creditRating;
    if (commonInput) {
      [entityCredit, historicQueries, creditGrantors, creditRating] = await makeRequestsWithDelay(
        commonInput,
        1000
      );
    } else {
      [entityCredit, historicQueries, creditGrantors, creditRating] = [null, null, null, null];
    }
    const creditResult = await axios.get(
      `${url}/${environment}/admin/credit-analysis/result?id=${input.id}`,
      commonInput
    );
    return [
      {
        maximumPayment: maximumPayment ? maximumPayment.data : null,
        creditAutofill: creditAutofill ? creditAutofill.data : null,
        borrowingCapacity: maximumPayment ? borrowingCapacity.data : null,
        entityCredit: entityCredit ? entityCredit.data : null,
        historicQueries: historicQueries ? historicQueries.data : null,
        creditGrantors: creditGrantors ? creditGrantors.data : null,
        creditRating: creditRating ? creditRating.data : null,
        creditResult: creditResult ? creditResult.data : null
      }
    ];
  } catch (error) {
    console.error(error);
    throw new Error(error.errorMessage || 'Unknown error');
  }
};
